import React from "react";
import { FormRuntime } from "../../FormRuntime";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { FormConfiguration } from "../../FormConfiguration";

export const InlineRichEditFormStories = [
    new StoryNode(
        () => {
            return <FormRuntime form={new FormConfiguration()}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Inline Rich Text Edit - MISSING"
    ),
];
